export const MapError = error => {
  return error
    .replace('GraphQL error:', '')
    .replaceAll('"', '')
    .replaceAll(';', ', ')
    .replaceAll('', '')
}
